module.exports = __webpack_public_path__ + "img/img_promotion_03.0e324edf.png";